import surveys from "@/store/modules/surveys/surveys";
import comments from "@/store/modules/surveys/comments";
import notification from "@/store/modules/surveys/notification";
import actionItem from "@/store/modules/surveys/actionItem";
import actionItemComment from "@/store/modules/surveys/actionItemComment";
import answerSession from "@/store/modules/surveys/answer-session";
import period from "@/store/modules/surveys/period";

export default {
    namespaced: true,
    modules: {
        surveys,
        comments,
        notification,
        actionItem,
        actionItemComment,
        answerSession,
        period,
    },
};
